import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { Globals } from "../../globals";
import { AngularFireAuth } from 'angularfire2/auth';
import { TranslateService } from '@ngx-translate/core';


//interface
interface User {
    UID: string;
    email: string;
    name: string;
    date: string;
    rol: string;
    uid_user_auth: string;
}


@Injectable()
export class AuthServices {
    private firestore: any;
    usersCol: AngularFirestoreCollection<User>;
    users: Observable<User[]>;
    dishes_variations: Observable<User[]>;
    dishDoc: AngularFirestoreDocument<User>;
    deleteStat: boolean = false;

    //TMP - Son variables a utilizar en diferentes puntos de la creacio/edicion para enviar modificar la informacion de diferentes componentes
    public dish_tags = Array();
    public dish_allergens_tmp = Array();

    public page_show = 'register'; //login | register

    constructor(public afAuth: AngularFireAuth,
        public globals: Globals,
        public afs: AngularFirestore,
        public translate: TranslateService) {
        this.firestore = firebase.firestore();
    }

    getListDishesAuth(UID_RESTAURANT) {
        /*
        this.dishesCol = this.afs.collection('dish', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT));
        this.dishes = this.dishesCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as User;
                data.UID = a.payload.doc.id;
                return data;
            });
        });
        */
    }

    getUserData(user_uid) {

        //this.afs.collection('users', ref => ref.where('uid_user', '==', user_uid).get());
        const col = this.firestore.collection('users');

        const query = col.where('uid_user_auth', '==', user_uid);

        query.get().then(snapshot => {
            snapshot.docs.forEach(doc => {
            })
        })
    }


    async getUserType(user_uid, user_email) {

        /*
       Funcion que mirar si un usuario puede acceder a mas de un restaurante o es Super (Emails de mycheftool devs)
       User type:
       indv
       multi
       super
        */

        const col = this.firestore.collection('users');
        const query = col.where('uid_user_auth', '==', user_uid);

        var _type;

        if (user_email === 'dev@mycheftool.com') {
            _type = 'super'
        } else {
            await query.get().then(snapshot => {
                snapshot.docs.forEach(doc => {
                    var _doc = doc.data()
                    if (Object.keys(_doc.restaurants).length > 1) {
                        _type = 'multi'
                    } else {
                        _type = 'indv'
                    }
                })
            })
        }

        return _type
    };

    async updateUserGlobals(user_uid, user_email) {
        const col = this.firestore.collection('users');
        const query = col.where('uid_user_auth', '==', user_uid);

        //user type dev
        //dev@mycheftool.com
        if (user_email === 'dev@mycheftool.com') {
            this.globals.user_type = 'super';
        } else {
            await query.get().then(snapshot => {
                snapshot.docs.forEach(doc => {
                    var _doc = doc.data()
                    _doc.UID = doc.id
                    //save in globals name, email and user_uid
                    this.globals.user_name = _doc.name;
                    this.globals.user_email = _doc.email;
                    this.globals.user_uid = doc.id;
                    this.globals.user_uid_auth = user_uid;
                    //globals user_type search user_type
                    if (Object.keys(_doc.restaurants).length > 1) {

                        //si + 1 rest mirar rol per si es profesor (sempre primera posicio profesor)
                        if (_doc.restaurants[0].rol == 'teacher') {
                            this.globals.user_type = 'teacher';
                            this.globals.school_uid = _doc.restaurants[0].UID_SCHOOL;
                        } else {//multi
                            var rests_user = [];
                            Object.keys(_doc.restaurants).forEach(key => {
                                rests_user[key] = {
                                    0: _doc.restaurants[key].UID_RESTAURANT,
                                    1: _doc.restaurants[key].rol,
                                    2: _doc.name,
                                    3: _doc.UID,
                                }
                                if (_doc.restaurants[key].disable != undefined) {
                                    this.globals.user_disable = _doc.restaurants[key].disable;
                                } else {
                                    this.globals.user_disable = false;
                                }
                            });
                            this.globals.rests_user = rests_user;
                            this.globals.user_type = 'multi';
                        }




                    } else {

                        Object.keys(_doc.restaurants).forEach(key => {
                            //if type
                            if (_doc.restaurants[key].rol == 'principal') {
                                this.globals.user_type = 'principal';
                                this.globals.school_uid = _doc.restaurants[key].UID_SCHOOL;
                            } else if (_doc.restaurants[key].rol == 'teacher') {
                                this.globals.user_type = 'teacher';
                                this.globals.school_uid = _doc.restaurants[key].UID_SCHOOL;
                            } else {
                                this.globals.user_type = 'indv';
                            }
                            //get restaurant UID
                            let uid = _doc.restaurants[key].UID_RESTAURANT;
                            this.globals.restaurant_uid = uid;
                            //get rol user in restarant
                            let _rol = _doc.restaurants[key].rol;
                            let _access = _doc.restaurants[key].access;
                            this.globals.user_rol = _rol;
                            this.globals.user_access = _access || ['admin'];
                            this.globals.waiter = _doc.name;
                            this.globals.waiter_uid = doc.id;

                            if (_doc.restaurants[key].disable != undefined) {
                                this.globals.user_disable = _doc.restaurants[key].disable;
                            } else {
                                this.globals.user_disable = false;
                            }

                        });
                    }
                })
            })
        }

    }

    async updateUserRolIndvGlobals(user_uid) {
        const col = this.firestore.collection('users');
        const query = col.where('uid_user_auth', '==', user_uid);

        await query.get().then(snapshot => {
            snapshot.docs.forEach(doc => {
                var _doc = doc.data()
                Object.keys(_doc.restaurants).forEach(key => {
                    let value = _doc.restaurants[key].rol;
                    let _access = _doc.restaurants[key].rol;
                    this.globals.user_rol = value;
                    this.globals.user_access = _access || ['admin'];

                    if (this.globals.user_rol == 'waiter') {
                        this.globals.waiter = _doc.name;
                        this.globals.waiter_uid = doc.id;
                    } else {
                        this.globals.waiter = _doc.name;
                        this.globals.waiter_uid = doc.id;
                    }
                });
            })
        })

    }

    async updateRestaurantUidIndvGlobals(user_uid) {
        const col = this.firestore.collection('users');
        const query = col.where('uid_user_auth', '==', user_uid);

        await query.get().then(snapshot => {
            snapshot.docs.forEach(doc => {
                var _doc = doc.data()
                Object.keys(_doc.restaurants).forEach(key => {
                    let value = _doc.restaurants[key].UID_RESTAURANT;
                    this.globals.restaurant_uid = value;
                });
            })
        });

    }

    async updateRestaurantSetupInitialGlobals(uid) {

        const restRef = this.firestore.collection('restaurants').doc(uid);

        await restRef.get().then(doc => {
            var _rest = doc.data();

            var str = _rest.currency;
            this.globals.user_currency = str.substring(str.lastIndexOf("(") + 1,
                str.lastIndexOf(")"));
            this.globals.user_tax_name = _rest.tax_name;
            this.globals.user_tax = _rest.tax_percentage;
            this.globals.user_timezone = _rest.timezone;




        });
    }

    public restaurant_uid = '';
    public room_uid = '';

    async createRestaurant(name, company, phone, email, address) {
        //Crear el restaurante y devuelve la uid
        var restaurant: any;

        await this.afs.collection('restaurants').add({
            'address': address,
            'license': 'pro_trial',
            'name': name,
            'company': company,
            'phone': phone,
            'email': email,
            'provider': 'general',
            'number': 1,
            'fiscal_name': '',
            'cif': '',
            'currency': 'Euro (EUR)',
            'tax_name': 'IVA',
            'tax_percentage': '10',
            'timezone': 'Europe/Madrid',
            'tickets': {
                'footer': '',
                'header': {
                    'address': true,
                    'company': true,
                    'email': false,
                    'logo': true,
                    'phone': false,
                    'waiter': false,
                    'room': false,
                    'table': true,
                },
                'show_time': true,
                'show_client': false,
            },
            'tutorial': '',
            'addon_user_arrival': true,
            'created_at': new Date(),
            'pro_trial_date': new Date(),
            'pro_trial_given': 1,
            'plg_cartamenu_finisher': false,
            'plg_cartamenu_winner': false,
            'register_step': 'setup1',
            'lang': this.globals.returnLangBrowser(this.translate.getBrowserLang())
        }).then(async doc => {
            restaurant = doc.id;
            this.restaurant_uid = await doc.id;
        });

        return restaurant;
    }

    async initRestaurant(company) {
        //insert provider
        await this.afs.collection('providers').add({
            'UID_RESTAURANT': this.restaurant_uid,
            'name': this.translate.instant('general-sin-proveedor'),
            'no_provider': true
        });

        //insert room
        await this.afs.collection('rooms').add({
            'UID_RESTAURANT': this.restaurant_uid,
            'name': this.translate.instant('general-nombre-comedor'),
        }).then(async ref => {
            this.room_uid = ref.id;
        });

        //insert cash
        await this.afs.collection('cashs').add({
            'UID_RESTAURANT': this.restaurant_uid,
            'name': this.translate.instant('general-nombre-caja'),
            'number': 0,
        }).then(async ref => {
            //insert table bar
            await this.afs.collection('tables').add({
                'UID_RESTAURANT': this.restaurant_uid,
                'name': 'bar',
                'type': 'bar',
                'customer': {},
                'ticket': {
                    'amount': 0,
                    'date': '',
                    'list': {},
                    'number': '',
                    'payment': false,
                    'payment_type': '',
                    'waiter': '',
                    'waiter_uid': '',
                    'tip': 0
                },
                'cash_static': this.translate.instant('general-nombre-caja'),
                'cash_uid': ref.id,
                'order': 0,
            })

            //insert first table
            await this.afs.collection('tables').add({
                'UID_RESTAURANT': this.restaurant_uid,
                'cash_static': this.translate.instant('general-nombre-caja'),
                'cash_uid': ref.id,
                'name': this.translate.instant('general-mesa-1'),
                'persons': 4,
                'size': '4',
                'state': 'open',
                'customer': {},
                'ticket': {
                    'amount': 0,
                    'date': '',
                    'list': {},
                    'number': '',
                    'payment': false,
                    'payment_type': '',
                    'waiter': '',
                    'waiter_uid': '',
                    'tip': 0
                },
                'type': 'table',
                'uid_room': this.room_uid,
                'order': 0,
            })

            //insert second table
            await this.afs.collection('tables').add({
                'UID_RESTAURANT': this.restaurant_uid,
                'cash_static': this.translate.instant('general-nombre-caja'),
                'cash_uid': ref.id,
                'name': this.translate.instant('general-mesa-2'),
                'persons': 4,
                'size': '4',
                'state': 'open',
                'customer': {},
                'ticket': {
                    'amount': 0,
                    'date': '',
                    'list': {},
                    'number': '',
                    'payment': false,
                    'payment_type': '',
                    'waiter': '',
                    'waiter_uid': '',
                    'tip': 0
                },
                'type': 'table',
                'uid_room': this.room_uid,
                'order': 1,
            })
        });
        //generate public key
        var domini_name = company;
        //clean string
        domini_name = this.globals.cleanString(/[^a-z0-9.-]/ig, domini_name, 'lowercase');
        //check if exist
        var public_key = await this.getDomini(domini_name);
        //if exist
        if (public_key && public_key.UID !== undefined) {
            var code = this.restaurant_uid.substring(this.restaurant_uid.length - 4).toLowerCase();
            domini_name = domini_name + '' + code;
        }
        //generate public_key
        await this.afs.collection('public_key').add({
            UID_RESTAURANT: this.restaurant_uid,
            domini: domini_name
        });
        //insert dishes
        let default_dishes = [
            {
                'UID_RESTAURANT': this.restaurant_uid,
                'name_es': 'Hamburguesa con queso y beicon',
                'name_en': 'Hamburguesa con queso y beicon',
                'name_fr': 'Hamburguesa con queso y beicon',
                'name_it': 'Hamburguesa con queso y beicon',
                'name_de': 'Hamburguesa con queso y beicon',
                'name_ca': 'Hamburguesa con queso y beicon',
                'description_es': 'Carne 100% de vacuno con bacon ahumado, cebolla, doble queso y nuestra deliciosa salsa de bacon, todo envuelto en un pan de sésamo tostado.',
                'description_en': 'Carne 100% de vacuno con bacon ahumado, cebolla, doble queso y nuestra deliciosa salsa de bacon, todo envuelto en un pan de sésamo tostado.',
                'description_fr': 'Carne 100% de vacuno con bacon ahumado, cebolla, doble queso y nuestra deliciosa salsa de bacon, todo envuelto en un pan de sésamo tostado.',
                'description_it': 'Carne 100% de vacuno con bacon ahumado, cebolla, doble queso y nuestra deliciosa salsa de bacon, todo envuelto en un pan de sésamo tostado.',
                'description_de': 'Carne 100% de vacuno con bacon ahumado, cebolla, doble queso y nuestra deliciosa salsa de bacon, todo envuelto en un pan de sésamo tostado.',
                'description_ca': 'Carne 100% de vacuno con bacon ahumado, cebolla, doble queso y nuestra deliciosa salsa de bacon, todo envuelto en un pan de sésamo tostado.',
                'tags': ['Hamburguesas'],
                'tags_static': 'Hamburguesas',
                'foodcost_static': 0,
                'foodcost_parts': 1,
                'price': 15,
                'price_half': 0,
                'price_tapa': 0,
                'price_combo_extra': 0,
                'price_supplement': 0,
                'price_takeaway': 15,
                'foodcost': Array(),
                'tax': 10,
                'allergens': ['50bkEzjuWbQGCB7IjrEf', 'Io13IxX1i5BnOpjoyZBF'],
                'image': 'dish/predefinits/burger.jpg',
                'favourite': false,
                'tpv_active': true,
                'type_unit': 'ud',
                'created_at': new Date(),
                'updated_at': new Date(),
            },
            {
                'UID_RESTAURANT': this.restaurant_uid,
                'name_es': 'Ensalada mixta',
                'name_en': 'Ensalada mixta',
                'name_fr': 'Ensalada mixta',
                'name_it': 'Ensalada mixta',
                'name_de': 'Ensalada mixta',
                'name_ca': 'Ensalada mixta',
                'description_es': 'Compuesta de lechuga romana, tomate, setas, pepino, maíz dulce y huevo cocido.',
                'description_en': 'Compuesta de lechuga romana, tomate, setas, pepino, maíz dulce y huevo cocido.',
                'description_fr': 'Compuesta de lechuga romana, tomate, setas, pepino, maíz dulce y huevo cocido.',
                'description_it': 'Compuesta de lechuga romana, tomate, setas, pepino, maíz dulce y huevo cocido.',
                'description_de': 'Compuesta de lechuga romana, tomate, setas, pepino, maíz dulce y huevo cocido.',
                'description_ca': 'Compuesta de lechuga romana, tomate, setas, pepino, maíz dulce y huevo cocido.',
                'tags': ['Ensaladas'],
                'tags_static': 'Ensaladas',
                'foodcost_static': 0,
                'foodcost_parts': 1,
                'price': 10,
                'price_half': 0,
                'price_tapa': 0,
                'price_combo_extra': 0,
                'price_supplement': 0,
                'price_takeaway': 10,
                'foodcost': Array(),
                'tax': 10,
                'allergens': [],
                'image': 'dish/predefinits/salad.jpg',
                'favourite': false,
                'tpv_active': true,
                'type_unit': 'ud',
                'created_at': new Date(),
                'updated_at': new Date(),
            },
            {
                'UID_RESTAURANT': this.restaurant_uid,
                'name_es': 'Sushi',
                'name_en': 'Sushi',
                'name_fr': 'Sushi',
                'name_it': 'Sushi',
                'name_de': 'Sushi',
                'name_ca': 'Sushi',
                'description_es': '4- Salmón: salmón, lechuga, pepino y salsa wasabi. 4- Pepino: Pepino, cebolla, aguacate',
                'description_en': '4- Salmón: salmón, lechuga, pepino y salsa wasabi. 4- Pepino: Pepino, cebolla, aguacate',
                'description_fr': '4- Salmón: salmón, lechuga, pepino y salsa wasabi. 4- Pepino: Pepino, cebolla, aguacate',
                'description_it': '4- Salmón: salmón, lechuga, pepino y salsa wasabi. 4- Pepino: Pepino, cebolla, aguacate',
                'description_de': '4- Salmón: salmón, lechuga, pepino y salsa wasabi. 4- Pepino: Pepino, cebolla, aguacate',
                'description_ca': '4- Salmón: salmón, lechuga, pepino y salsa wasabi. 4- Pepino: Pepino, cebolla, aguacate',
                'tags': ['Entrantes', 'Sushi'],
                'tags_static': 'Entrantes,Sushi',
                'foodcost_static': 0,
                'foodcost_parts': 1,
                'price': 12,
                'price_half': 0,
                'price_tapa': 0,
                'price_combo_extra': 0,
                'price_supplement': 0,
                'price_takeaway': 12,
                'foodcost': Array(),
                'tax': 10,
                'allergens': ['H4W23Lv4XHx4qpZCEbYN'],
                'image': 'dish/predefinits/sushi.jpg',
                'favourite': false,
                'tpv_active': true,
                'type_unit': 'ud',
                'created_at': new Date(),
                'updated_at': new Date(),
            },
            {
                'UID_RESTAURANT': this.restaurant_uid,
                'name_es': 'Pollo a la plancha con espárragos',
                'name_en': 'Pollo a la plancha con espárragos',
                'name_fr': 'Pollo a la plancha con espárragos',
                'name_it': 'Pollo a la plancha con espárragos',
                'name_de': 'Pollo a la plancha con espárragos',
                'name_ca': 'Pollo a la plancha con espárragos',
                'description_es': 'Delicioso pollo de corral a la plancha con espárragos campestres.',
                'description_en': 'Delicioso pollo de corral a la plancha con espárragos campestres.',
                'description_fr': 'Delicioso pollo de corral a la plancha con espárragos campestres.',
                'description_it': 'Delicioso pollo de corral a la plancha con espárragos campestres.',
                'description_de': 'Delicioso pollo de corral a la plancha con espárragos campestres.',
                'description_ca': 'Delicioso pollo de corral a la plancha con espárragos campestres.',
                'tags': ['Segundos', 'Brasa'],
                'tags_static': 'Segundos,Brasa',
                'foodcost_static': 0,
                'foodcost_parts': 1,
                'price': 10,
                'price_half': 0,
                'price_tapa': 0,
                'price_combo_extra': 0,
                'price_supplement': 0,
                'price_takeaway': 10,
                'foodcost': Array(),
                'tax': 10,
                'allergens': [],
                'image': 'dish/predefinits/grilled.png',
                'favourite': false,
                'tpv_active': true,
                'type_unit': 'ud',
                'created_at': new Date(),
                'updated_at': new Date(),
            },
            {
                'UID_RESTAURANT': this.restaurant_uid,
                'name_es': 'Pizza pepperoni',
                'name_en': 'Pizza pepperoni',
                'name_fr': 'Pizza pepperoni',
                'name_it': 'Pizza pepperoni',
                'name_de': 'Pizza pepperoni',
                'name_ca': 'Pizza pepperoni',
                'description_es': 'Pizza pepperoni massa fina y crujiente con mozzarella de búfala fresca y aceitunas negras.',
                'description_en': 'Pizza pepperoni massa fina y crujiente con mozzarella de búfala fresca y aceitunas negras.',
                'description_fr': 'Pizza pepperoni massa fina y crujiente con mozzarella de búfala fresca y aceitunas negras.',
                'description_it': 'Pizza pepperoni massa fina y crujiente con mozzarella de búfala fresca y aceitunas negras.',
                'description_de': 'Pizza pepperoni massa fina y crujiente con mozzarella de búfala fresca y aceitunas negras.',
                'description_ca': 'Pizza pepperoni massa fina y crujiente con mozzarella de búfala fresca y aceitunas negras.',
                'tags': ['Pizzas'],
                'tags_static': 'Pizzas',
                'foodcost_static': 0,
                'foodcost_parts': 1,
                'price': 15,
                'price_half': 0,
                'price_tapa': 0,
                'price_combo_extra': 0,
                'price_supplement': 0,
                'price_takeaway': 15,
                'foodcost': Array(),
                'tax': 10,
                'allergens': ['50bkEzjuWbQGCB7IjrEf', 'Io13IxX1i5BnOpjoyZBF'],
                'image': 'dish/predefinits/pizza.jpg',
                'favourite': false,
                'tpv_active': true,
                'type_unit': 'ud',
                'created_at': new Date(),
                'updated_at': new Date(),
            },
            {
                'UID_RESTAURANT': this.restaurant_uid,
                'name_es': 'Pasta fresca con aguacate',
                'name_en': 'Pasta fresca con aguacate',
                'name_fr': 'Pasta fresca con aguacate',
                'name_it': 'Pasta fresca con aguacate',
                'name_de': 'Pasta fresca con aguacate',
                'name_ca': 'Pasta fresca con aguacate',
                'description_es': 'Pasta fresca con aguacate y tacos de pollo marinado a la finas hierbas.',
                'description_en': 'Pasta fresca con aguacate y tacos de pollo marinado a la finas hierbas.',
                'description_fr': 'Pasta fresca con aguacate y tacos de pollo marinado a la finas hierbas.',
                'description_it': 'Pasta fresca con aguacate y tacos de pollo marinado a la finas hierbas.',
                'description_de': 'Pasta fresca con aguacate y tacos de pollo marinado a la finas hierbas.',
                'description_ca': 'Pasta fresca con aguacate y tacos de pollo marinado a la finas hierbas.',
                'tags': ['Pasta', 'Entrantes'],
                'tags_static': 'Pasta,Entrantes',
                'foodcost_static': 0,
                'foodcost_parts': 1,
                'price': 12,
                'price_half': 0,
                'price_tapa': 0,
                'price_combo_extra': 0,
                'price_supplement': 0,
                'price_takeaway': 12,
                'foodcost': Array(),
                'tax': 10,
                'allergens': ['50bkEzjuWbQGCB7IjrEf'],
                'image': 'dish/predefinits/pasta.jpg',
                'favourite': false,
                'tpv_active': true,
                'type_unit': 'ud',
                'created_at': new Date(),
                'updated_at': new Date(),
            },
            {
                'UID_RESTAURANT': this.restaurant_uid,
                'name_es': 'Pastel de chocolate',
                'name_en': 'Pastel de chocolate',
                'name_fr': 'Pastel de chocolate',
                'name_it': 'Pastel de chocolate',
                'name_de': 'Pastel de chocolate',
                'name_ca': 'Pastel de chocolate',
                'description_es': 'Pastel de chocolate artesanal con frutos rojos.',
                'description_en': 'Pastel de chocolate artesanal con frutos rojos.',
                'description_fr': 'Pastel de chocolate artesanal con frutos rojos.',
                'description_it': 'Pastel de chocolate artesanal con frutos rojos.',
                'description_de': 'Pastel de chocolate artesanal con frutos rojos.',
                'description_ca': 'Pastel de chocolate artesanal con frutos rojos.',
                'tags': ['Postres'],
                'tags_static': 'Postres',
                'foodcost_static': 0,
                'foodcost_parts': 1,
                'price': 8,
                'price_half': 0,
                'price_tapa': 0,
                'price_combo_extra': 0,
                'price_supplement': 0,
                'price_takeaway': 8,
                'foodcost': Array(),
                'tax': 10,
                'allergens': ['50bkEzjuWbQGCB7IjrEf', 'Io13IxX1i5BnOpjoyZBF'],
                'image': 'dish/predefinits/dessert.jpg',
                'favourite': false,
                'tpv_active': true,
                'type_unit': 'ud',
                'created_at': new Date(),
                'updated_at': new Date(),
            },
            {
                'UID_RESTAURANT': this.restaurant_uid,
                'name_es': 'Cocktail Basílico',
                'name_en': 'Cocktail Basílico',
                'name_fr': 'Cocktail Basílico',
                'name_it': 'Cocktail Basílico',
                'name_de': 'Cocktail Basílico',
                'name_ca': 'Cocktail Basílico',
                'description_es': 'Cocktail muy refrescante compuesto de ginebra y lima con un toque de zumo de manzana.',
                'description_en': 'Cocktail muy refrescante compuesto de ginebra y lima con un toque de zumo de manzana.',
                'description_fr': 'Cocktail muy refrescante compuesto de ginebra y lima con un toque de zumo de manzana.',
                'description_it': 'Cocktail muy refrescante compuesto de ginebra y lima con un toque de zumo de manzana.',
                'description_de': 'Cocktail muy refrescante compuesto de ginebra y lima con un toque de zumo de manzana.',
                'description_ca': 'Cocktail muy refrescante compuesto de ginebra y lima con un toque de zumo de manzana.',
                'tags': ['Postres', 'Cocktails'],
                'tags_static': 'Postres,Cocktails',
                'foodcost_static': 0,
                'foodcost_parts': 1,
                'price': 8,
                'price_half': 0,
                'price_tapa': 0,
                'price_combo_extra': 0,
                'price_supplement': 0,
                'price_takeaway': 8,
                'foodcost': Array(),
                'tax': 10,
                'allergens': [],
                'image': 'dish/predefinits/cocktail.jpg',
                'favourite': false,
                'tpv_active': true,
                'type_unit': 'ud',
                'created_at': new Date(),
                'updated_at': new Date(),
            }
        ];
        for (let default_dish of default_dishes) {
            await this.afs.collection('dish').add(default_dish);
        }
    }

    uid_user: any;
    async createUserRestaurant(email, name, uid_user, uid_restaurant) {
        //Crear el restaurante y devuelve la uid

        await this.afs.collection('users').add({
            'email': email,
            'name': name,
            'uid_user_auth': uid_user,
            'restaurants': {
                0: {
                    'UID_RESTAURANT': uid_restaurant,
                    'rol': 'admin',
                    'access': ['admin']
                }
            }

        }).then(doc => {
            //push
            this.uid_user = doc.id;
        });
    }

    async createUserRestaurantConfiguration(email, name, uid_user, uid_restaurant, rol, access = []) {
        //Crear el restaurante y devuelve la uid
        await this.afs.collection('users').add({
            'email': email,
            'name': name,
            'uid_user_auth': uid_user,
            'restaurants': {
                0: {
                    'UID_RESTAURANT': uid_restaurant,
                    'rol': rol,
                    'access': access
                }
            }
        }).then(doc => {
            //Añadir al globals el nuevo usuario
            this.globals.users.push({
                disable: false,
                email: email,
                name: name,
                rol: rol,
                access: access,
                uid: doc.id,
                uid_auth: uid_user
            });
        })
    }

    async getDomini(domini_name) {
        var public_key;
        try {
            const publicKeyRef = this.firestore.collection('public_key');
            await publicKeyRef.where('domini', '==', domini_name).get().then(snapshot => {
                snapshot.forEach(doc => {
                    public_key = doc.data();
                    public_key.UID = doc.id;
                });
            });
            return public_key
        } catch (error) {
            return public_key;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/auth/services.ts